import { createAsyncThunk } from '@reduxjs/toolkit';

function postMePasswordReset({ user }, { extra: { http } }) {
  return http.post(`/me/password_reset`, { user });
}
function patchMePasswordReset({ user }, { extra: { http } }) {
  return http.patch(`/me/password_reset`, { user });
}

export const createMePasswordReset = createAsyncThunk(
  'me/password_reset/create',
  postMePasswordReset
);
export const updateMePasswordReset = createAsyncThunk(
  'me/password_reset/update',
  patchMePasswordReset
);
